<template>
  <div>
    <h3>Reports and Dashboards</h3>
    <b-row>
      <b-col><workloads-summary /></b-col>
      <b-col><course-plan /></b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import workloadsSummary from "./reports/workloads-summary";
import coursePlan from "./reports/course-plan-report";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {};
  },

  components: {
    workloadsSummary,
    coursePlan,
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  created() {},
};
</script>

<style scoped>
</style>
